import { Check as CheckIcon, RotateCcw } from 'lucide-react'
import {
  useSetProblemOccurrenceStatusMutation,
  type ProblemOccurrence,
  type WorkScope
} from '@axilon-apps/domains-ontology-ui-state'
import { Button } from '../ui/button'

/**
 * Close an open problem or reopen a closed one, at the version the caller
 * read. `canAct` follows the occurrence's own allowed actions.
 */
export function useOccurrenceStatusAction(scope: WorkScope, occurrence: ProblemOccurrence) {
  const closed = occurrence.status === 'closed'
  const canAct = closed ? occurrence.allowed_actions.reopen : occurrence.allowed_actions.close
  const [mutate, { isLoading: acting, error }] = useSetProblemOccurrenceStatusMutation()
  const act = () =>
    void mutate({
      ...scope,
      id: occurrence.id,
      action: closed ? 'reopen' : 'close',
      expectedVersion: occurrence.version,
      operationKey: crypto.randomUUID()
    })
  return { closed, canAct, acting, error, act }
}

export function OccurrenceStatusButton({
  action
}: {
  action: ReturnType<typeof useOccurrenceStatusAction>
}) {
  if (!action.canAct) return null
  return (
    <Button size="sm" variant="outline" disabled={action.acting} onClick={action.act}>
      {action.closed ? <RotateCcw size={14} /> : <CheckIcon size={14} />}
      {action.closed ? 'Reopen' : 'Close'}
    </Button>
  )
}
